import { Injectable } from '@angular/core';

//VS Code class definitions are outdated and does not fit the MDN Api
//Therefore creating own types here representing MDN
//https://developer.mozilla.org/de/docs/Web/API/HighlightRegistry
interface IrdHighlightRegistry extends HighlightRegistry {
  set(name: string, highlight: IrdHighlight);
}

//developer.mozilla.org/de/docs/Web/API/Highlight
interface IrdHighlight extends Highlight {
  add(range: Range);
  delete(range: Range);
}

@Injectable({ providedIn: 'root' })
export class HighlightService {
  private static readonly NAME = 'ird-highlight';

  private readonly registry: IrdHighlightRegistry;
  private readonly highlight: IrdHighlight = new Highlight() as IrdHighlight;

  constructor() {
    if (typeof CSS === 'undefined' || !CSS.highlights) {
      console.warn('Highlight API is not supported!');
    } else {
      this.registry = CSS.highlights as IrdHighlightRegistry;
      this.registry.set(HighlightService.NAME, this.highlight);
    }
  }

  public add(node: Node, start: number, end: number): Range {
    const range = new Range();
    range.setStart(node, start);
    range.setEnd(node, end);
    this.highlight.add(range);

    return range;
  }

  public delete(range: Range) {
    this.highlight.delete(range);
  }
}
